import { createContext, useCallback, useContext } from 'react';
import { useFormStore } from '@/stores/formStore';

// ─── Panel context ──────────────────────────────────────────────────────────

const PanelContext = createContext<string | null>(null);
export const PanelProvider = PanelContext.Provider;

export const useCollapsible = (panelId: string) => {
  const isCollapsed = useFormStore((s) => s.collapsedPanels[panelId] ?? false);
  const _set = useFormStore((s) => s.setIsCollapsed);

  const setIsCollapsed = useCallback(
    (collapsed: boolean) => _set(panelId, collapsed),
    [_set, panelId],
  );

  return { isCollapsed, setIsCollapsed } as const;
};

export const usePanelCollapse = () => {
  const panelId = useContext(PanelContext);
  if (!panelId) {
    throw new Error(
      'usePanelCollapse must be used within a DraggableDialog (PanelProvider)',
    );
  }
  return useCollapsible(panelId);
};
